/**
 * Trap focus within a section of the DOM.
 * Useful for modals / off-screen navigation where you need to trap focus within a particular area.
 * @param {string} element Takes a reference to a DOM element (usually a wrapper)
 */
export default function trapFocus(element) {
  element.tabIndex = -1; // eslint-disable-line no-param-reassign
  setTimeout(() => {
    element.focus({
      preventScroll: true,
    });
  }, 250);
  const focusableEls = element.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]),input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
  );
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;

  element.addEventListener('keydown', (e) => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === lastFocusableEl) {
      /* tab */
      firstFocusableEl.focus();
      e.preventDefault();
    }
  });
}
